import writeXlsxFile from "write-excel-file";
import { fetchRegistersReports } from "../../../../utils/services/portalBoticario";

export async function createRegistersXlsx(jwt, setFinishExport, idEvent) {
  const schema = [
    {
      column: "ID",
      type: String,
      value: (data) => data.id,
    },
    {
      column: "E-mail",
      type: String,
      value: (data) => data.email,
    },
    {
      column: "Nome",
      type: String,
      value: (data) => data.nome,
    },
    {
      column: "Departamento",
      type: String,
      value: (data) => data.codigo_interno_1,
    },
  ];

  const data = await fetchRegistersReports(jwt, idEvent);

  const progressBar = document.querySelector(".export-progress");
  const percentageBar = document.querySelector(".export-percentage");
  if (progressBar) progressBar.style.width = "100%";
  if (percentageBar) percentageBar.innerHTML = "100%";

  if (data && data.length > 0) {
    await writeXlsxFile(data, {
      schema,
      fileName: "registradores_boticario_cotas.xlsx",
    });
  }

  setTimeout(() => {
    setFinishExport(true);
  }, 1000);
}
